// ======================================================================
// File Name       : ContentDrillRegisterConfirmDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { MODAL_SIZE } from '../../constants/index';
import ContentDrillDetail from './ContentDrillDetail';

const contentDrillRegisterConfirmDialog = ({
  onDialogOK,
  onDialogCancel,
  drillDetail,
  showModal,
  questionDrillList,
  questionDrillListArr,
  markRule,
}) => {
  const style = {
    background: 'none',
    width: 'auto',
    minWidth: '600px',
    marginLeft: 0,
    left: 0,
  };
  const data = drillDetail();
  let drillInfo = null;
  if (data !== undefined) {
    drillInfo = data.drillInfo;
  }
  return (
    <Modal
      className="modal-container"
      show={showModal}
      style={style}
      size={MODAL_SIZE.lg}
    >

      <Modal.Header onHide={onDialogCancel} closeButton>
        <Modal.Title className="text-center">
          以下の内容で登録します
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ContentDrillDetail
          drillDetailInfo={drillInfo}
          isDetail
          questionDrillList={questionDrillList}
          questionDrillListArr={questionDrillListArr}
          markRule={markRule}
        />
      </Modal.Body>

      <Modal.Footer className="text-center">
        <Button
          variant="default"
          className=" margin-right-10 btn-96"
          onClick={onDialogCancel}
        >
          キャンセル
        </Button>
        <Button
          className=" margin-left-10 btn-96"
          variant="primary"
          onClick={onDialogOK}
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default contentDrillRegisterConfirmDialog;
